import { render, staticRenderFns } from "./tip-configuration.vue?vue&type=template&id=38c15988&scoped=true&"
import script from "./tip-configuration.vue?vue&type=script&lang=js&"
export * from "./tip-configuration.vue?vue&type=script&lang=js&"
import style0 from "./tip-configuration.vue?vue&type=style&index=0&id=38c15988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c15988",
  null
  
)

export default component.exports